module.exports = __webpack_public_path__ + "img/product_dietz_sgt.6e9b6a2d.jpg";